import currency from "currency.js";

export const getTotalForwardTradeValue = (price: string | number, volume: number) => currency(price).multiply(volume);
